module.exports = __webpack_public_path__ + "static/media/25-6.f23c4f91.mp3";